/* eslint-disable sonarjs/no-duplicate-string */
import { colors } from '@material-ui/core';

export const features = {
  items: [
    {
      icon: 'fas fa-bolt',
      title: 'Rápido',
      subtitle: 'Rápida implantação, sem necessidade de conhecimento técnico',
    },
    {
      icon: 'fas fa-puzzle-piece',
      title: 'Flexível',
      subtitle:
        'Ajuste a experiência de acordo com o tipo de produto ou serviço que precisa vender',
    },
    {
      icon: 'fas fa-bullseye',
      title: 'Customizado',
      subtitle: 'Interface com seu logotipo e as cores da sua marca',
    },
    {
      icon: 'fas fa-credit-card',
      title: 'Pagamento',
      subtitle:
        'Meio de pagamento integrado para boleto bancário e cartão de crédito, sem burocracia',
    },
  ],
  properties: [
    'Baixo investimento para começar a vender',
    'Funcionalidades exclusivas para venda em educação',
    'Meio de pagamento integrado de forma nativa',
  ],
};

export const mobileapp = [
  'Venda qualquer tipo de produto físico, digital ou até mesmo serviços',
  'Gerencie o plano de cobrança dos cursos pela plataforma',
  'Confirmação de leitura e aceite de termos de aceite durante a compra',
  'Colete informações adicionais para customização de produtos ou serviços',
];

export const categories = [
  {
    color: colors.blue,
    icon: 'fas fa-store-alt',
    title: 'Marketplace',
    subtitle: 'Venda produtos ou serviços de terceiros em sua loja.',
    href: '/platform/marketplace',
  },
  {
    color: colors.blue,
    icon: 'fas fa-shopping-cart',
    title: 'E-commerce',
    subtitle: 'Venda seus próprios produtos ou serviços para seus consumidores.',
    href: '/platform/e-commerce',
  },
  {
    color: colors.blue,
    icon: 'fas fa-building',
    title: 'Seller',
    subtitle: 'Venda seus próprios produtos ou serviços em outros lojas.',
    href: '/platform/seller',
  },
  {
    color: colors.deepOrange,
    icon: 'fas fa-headset',
    title: 'Pré-venda',
    subtitle: 'Suporte para pré-venda aos consumidores durante a compra.',
    href: '/platform/pre-sales',
  },
  {
    color: colors.deepOrange,
    icon: 'fas fa-file-invoice-dollar',
    title: 'Orçamentos',
    subtitle: 'Envie orçamentos prontos para compra para seus clientes.',
    href: '/platform/budgets',
  },
  {
    color: colors.deepOrange,
    icon: 'fas fa-concierge-bell',
    title: 'Concierge',
    subtitle: 'Surpreenda no atendimento aos clientes facilitando a compra.',
    href: '/platform/concierge',
  },
  {
    color: colors.green,
    icon: 'fas fa-credit-card',
    title: 'Formas de pagamento',
    subtitle: 'Venda através de boleto bancário e cartão de crédito',
    href: '/platform/payment-methods',
  },
  {
    color: colors.green,
    icon: 'fas fa-chart-pie',
    title: 'Split de pagamentos',
    subtitle: 'Receba comissões sobre as vendas em tempo real',
    href: '/platform/payment-split',
  },
  {
    color: colors.green,
    icon: 'fas fa-cash-register',
    title: 'Conciliação',
    subtitle: 'Tenha suas informações de pedidos e financeiras conciliadas de ponta à ponta',
    href: '/platform/payment-conciliation',
  },
  {
    color: colors.pink,
    icon: 'fas fa-plug',
    title: 'Integrações',
    subtitle: 'Desenvolva sua própria integração ou utilize integrações disponíveis',
    href: '/platform/integrations',
  },
  {
    color: colors.pink,
    icon: 'fas fa-puzzle-piece',
    title: 'Power-ups',
    subtitle: 'Expanda novas funcionalidades através de customizações de terceiros',
    href: '/platform/power-ups',
  },
  {
    color: colors.pink,
    icon: 'fas fa-server',
    title: 'Providers',
    subtitle: 'Integração dedicada para sua necessidade',
    href: '/platform/providers',
  },
  {
    color: colors.purple,
    icon: 'fas fa-receipt',
    title: 'Pedido único',
    subtitle: 'Venda e cobre uma única vez',
    href: '/platform/orders',
  },
  {
    color: colors.purple,
    icon: 'fas fa-calendar-alt',
    title: 'Mensalidades',
    subtitle: 'Venda e cobre dentro de um plano de cobrança personalizado',
    href: '/platform/tuition',
  },
  {
    color: colors.purple,
    icon: 'fas fa-file-signature',
    title: 'Contratos',
    subtitle: 'Venda e cobra dentro de regras específicas',
    href: '/platform/contracts',
  },
  {
    color: colors.grey,
    icon: 'fas fa-box',
    title: 'Catálogo',
    subtitle: 'Gestão de produtos ou serviços educacionais',
    href: '/platform/catalog',
  },
  {
    color: colors.grey,
    icon: 'fas fa-tags',
    title: 'Promoções e cupons',
    subtitle: 'Customize campanhas e ofereça descontos durante a compra',
    href: '/platform/promotions',
  },
  {
    color: colors.grey,
    icon: 'fas fa-users',
    title: 'Clientes',
    subtitle: 'Gerencia seus clientes na plataforma',
    href: '/platform/customers',
  },
  {
    color: colors.grey,
    icon: 'fas fa-truck',
    title: 'Logística',
    subtitle: 'Configure cenários complexos de logística de entrega',
    href: '/platform/logistics',
  },
  {
    color: colors.grey,
    icon: 'fas fa-dollar-sign',
    title: 'Preços',
    subtitle: 'Configure preços gerais, por marketplace ou por cliente',
    href: '/platform/prices',
  },
];
